<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ba4"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('dict_search_button')" @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="getLimit('dict_add_button')" @click="funcAdd">
          新增
        </el-button>
        <el-button v-if="getLimit('dict_export_button')" @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      :loading="loading"
      row-id="id"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="code" title="编码" min-width="100" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.code"
            placeholder="请输入编码"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" title="名称" min-width="100" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          min-width="100"
          :formatter="formatterStatus"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remark"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="sort" title="排序" min-width="100" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.sort"
            placeholder="请输入排序"
            clearable
            @input="
              value =>
                formFormatter.isInteger(value, oldValue, listQuery, 'sort')
            "
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('dict_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.id)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('dict_delete_button') && isSuperAdmin"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.id)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="500"
      height="440"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="500"
      height="440"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/dictAdd.vue";
import compEdit from "./components/dictEdit.vue";
import request from "@/utils/request";
export default {
  name: "DictList",
  components: {
    compAdd,
    compEdit
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/dict/exportDictList", //导出接口
        name: "数据字典"
      },
      isSuperAdmin: false,
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      listQuery: {
        id: "",
        type: "",
        code: "",
        name: "",
        status: "",
        remark: "",
        sort: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 状态
      statusList: [{ label: "正常", value: 0 }, { label: "停用", value: 1 }],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  watch: {
    "$route.path": function(e) {
      this.listQuery = {
        id: "",
        type: "",
        code: "",
        name: "",
        status: "",
        remark: "",
        sort: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      };
      this.getDictType();
      this.oldValue = {};
    }
  },
  mounted() {
    const partyType = this.$store.getters.party.partyType;
    this.isSuperAdmin = partyType == "SUPER_ADMIN";
    this.getDictType();
  },
  methods: {
    // 获取数据字典类型
    getDictType() {
      const path = this.$route.path;
      var dictType = path.split("/dict/")[1];
      if (dictType == undefined) {
        dictType = path.split("/wmsChargingType/")[1];
      }
      this.listQuery.type = dictType;
      this.initQuery = JSON.stringify(this.listQuery);
      let name = "";
      switch (this.listQuery.type) {
        case "shipType":
          name = "船型管理";
          break;
        case "vehicleClassification":
          name = "车型管理";
          break;
        case "vehicleLength":
          name = "车长管理";
          break;
        case "vehicleWidth":
          name = "车宽管理";
          break;
        case "vehicleHigh":
          name = "车高管理";
          break;
        case "vehicleZhoushu":
          name = "轴数管理";
          break;
        case "vehicleTonnage":
          name = "吨位管理";
          break;
        case "vehicleCube":
          name = "立方管理";
          break;
        case "extraFeeType":
          name = "增值类型";
          break;
        case "bank":
          name = "银行类型";
          break;
        // case "cargoPacking":
        //   name = "cargoPacking"
        //   break;
        default:
          name = "数据字典";
          break;
      }
      this.exportObj.name = name;
      // 设置子组件字典类型
      this.$refs.addRef.formData.type = dictType;
      this.$refs.addRef.formData.type = dictType;
      if (
        dictType === "vehicleClassification" ||
        dictType === "vehicleLength" ||
        dictType === "vehicleWidth" ||
        dictType === "vehicleHigh"
      ) {
        this.$refs.addRef.codeTips =
          "请参照《网络货运信息交互代码集》维护编码，添加后不可修改删除";
      } else if (dictType === "vehicleTonnage") {
        this.$refs.addRef.codeTips =
          "吨位编码是纯数字（单位是吨）：如50吨，编码维护50；2500千克，编码维护2.5";
      }
      this.findList();
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/dict",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusList.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs.form.resetFields();
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(id) {
      this.$refs.editRef.getInfo(id);
      this.modelEditFlag = true;
    },
    // 删除方法
    funcDelete(id) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/dict`,
            method: "delete",
            params: { ids: id }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    }
  }
};
</script>
